import { useSelector } from "react-redux";

import { ComponentSocialMediaPage } from "@components";
import { selectAuth } from "@redux";


export const PageSocialMediaPage = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentSocialMediaPage
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
